/**
 * Determines whether the session prefetch should fire.
 * Gates on devicesReady so we don't call /join until a working mic is confirmed.
 * In demo mode, the devicesReady gate is bypassed so the prefetch can fire without a mic.
 */
export function shouldPrefetch({ isSpectator, groupCode, displayName, devicesReady, isSessionReady, error, prefetchedResponse, isDemoMode }) {
  const deviceGate = isDemoMode || devicesReady;
  return !isSpectator && !!groupCode && !!displayName && deviceGate && !isSessionReady && !error && !prefetchedResponse;
}
